import isString from 'lodash/isString';

export function formatPhoneHref(phone: any) {
  return isString(phone) ? `tel:${phone.replace(/\s+/g, '')}` : phone;
}

export function formatEmailHref(email: any) {
  return isString(email) ? `mailto:${email.replace(/\s+/g, '')}` : email;
}
